exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-row[data-v-540f1792] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.shipping-row .shipping-row-child[data-v-540f1792] {\n    color: green;\n    text-align: right;\n}\n.pre-line[data-v-540f1792] {\n  white-space: pre-line;\n  margin-top: -1em;\n  word-wrap: break-word;\n}\n@media (max-width: 768px) {\n.summary-title[data-v-540f1792] {\n    margin-left: 0;\n}\n}\n.loading__wrapper svg[data-v-540f1792] {\n  margin: 0 auto;\n}\n.loader__text span[data-v-540f1792] {\n  margin: 0 auto;\n}\n", ""]);

// exports
